(function ($) {
  window.ua = {};
  var ua = window.ua;
  ua.name = window.navigator.userAgent.toLowerCase();

  ua.isIE = ua.name.indexOf("msie") >= 0 || ua.name.indexOf("trident") >= 0;
  ua.isiPhone = ua.name.indexOf("iphone") >= 0;
  ua.isiPod = ua.name.indexOf("ipod") >= 0;
  ua.isiPad = ua.name.indexOf("ipad") >= 0;
  ua.isiOS = ua.isiPhone || ua.isiPod || ua.isiPad;
  ua.isAndroid = ua.name.indexOf("android") >= 0;
  ua.isTablet = ua.isiPad || (ua.isAndroid && ua.name.indexOf("mobile") < 0);

  $.event.add(window, "load", function () {
    // 全ての読み込み完了後に呼ばれる関数

    /* debug
  	ctrl_body_scrl(true);
  	var anim = TweenMax.to( $('.wide_img'), 0.1, {opacity: 1});anim.delay(0);
  	var line5 = TweenMax.to( $('.wide_img_line5'),		0.1, {height: 9631,ease:Power3.easeIn});line5.delay(0);
  	var line5_1 = TweenMax.to( $('.history_line_wrap'),	0.1, {height: 9631,ease:Power3.easeIn});line5_1.delay(0);
  	return; */
    /* //debug */

    // $('html,body').animate({ scrollTop: 0 }, 1);
    ctrl_body_scrl(false);

    $(window).on("touchmove.noScroll", function (e) {
      e.preventDefault();
    });

    loadAnim();
    //init_Scrl();

    function loadAnim() {
      //Loadingからの全体表示
      //Loddingのフェードアウト

      var anim_load1 = TweenMax.to($("#Loading-Wrapper"), 0.5, {
        height: 0,
        opacity: 0,
      });
      anim_load1.delay(0.5);

      //全体表示からのアニメーション
      var anim = TweenMax.to($(".wide_img"), 1.5, { opacity: 1 });
      anim.delay(2.0);

      var anim2 = TweenMax.to($(".wide_img_text1"), 1.0, {
        width: 600,
        left: 300,
        ease: Power3.easeOut,
      });
      anim2.delay(2.5);
      var anim3 = TweenMax.to($(".textMask1"), 1.0, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      anim3.delay(2.5);

      var line1 = TweenMax.to($(".wide_img_line1"), 0.3, {
        width: 40,
        left: 580,
        ease: Power3.easeOut,
      });
      line1.delay(2.55);
      var line1_1 = TweenMax.to($(".lineMask1"), 0.3, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      line1_1.delay(2.55);

      var anim4 = TweenMax.to($(".wide_img_text2"), 0.3, {
        width: 40,
        left: 580,
        ease: Power3.easeOut,
      });
      anim4.delay(2.55);
      var anim5 = TweenMax.to($(".textMask2"), 0.3, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      anim5.delay(2.55);

      var line2 = TweenMax.to($(".wide_img_line2"), 0.3, {
        width: 40,
        left: 580,
        ease: Power3.easeOut,
      });
      line2.delay(2.55);
      var line2_1 = TweenMax.to($(".lineMask2"), 0.3, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      line2_1.delay(2.55);

      var anim6 = TweenMax.to($(".wide_img_text3"), 1.0, {
        width: 600,
        left: 300,
        ease: Power3.easeOut,
      });
      anim6.delay(2.6);
      var anim7 = TweenMax.to($(".textMask3"), 1.0, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      anim7.delay(2.6);

      var line3 = TweenMax.to($(".wide_img_line3"), 1.0, {
        width: 600,
        left: 300,
        ease: Power3.easeOut,
      });
      line3.delay(2.65);
      var line3_1 = TweenMax.to($(".lineMask3"), 1.0, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      line3_1.delay(2.65);

      var anim8 = TweenMax.to($(".wide_img_text4"), 1.0, {
        width: 600,
        left: 300,
        ease: Power3.easeOut,
      });
      anim8.delay(2.65);
      var anim9 = TweenMax.to($(".textMask4"), 1.0, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      anim9.delay(2.65);

      var anim10 = TweenMax.to($(".wide_img_text5"), 1.0, {
        width: 600,
        left: 300,
        ease: Power3.easeOut,
      });
      anim10.delay(2.7);
      var anim11 = TweenMax.to($(".textMask5"), 1.0, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      anim11.delay(2.7);

      var anim12 = TweenMax.to($(".wide_img_text6"), 1.0, {
        width: 600,
        left: 300,
        ease: Power3.easeOut,
      });
      anim12.delay(2.75);
      var anim13 = TweenMax.to($(".textMask6"), 1.0, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      anim13.delay(2.75);

      var line4 = TweenMax.to($(".wide_img_line4"), 1.0, {
        width: 600,
        left: 300,
        ease: Power3.easeOut,
      });
      line4.delay(2.75);
      var line4_1 = TweenMax.to($(".lineMask4"), 1.0, {
        css: { marginLeft: 0 },
        ease: Power3.easeOut,
      });
      line4_1.delay(2.75);

      var line5 = TweenMax.to($(".wide_img_line5"), 2.5, {
        height: 9791,
        ease: Power3.easeIn,
      });
      line5.delay(3.3);
      var line5_1 = TweenMax.to($(".history_line_wrap"), 3.2, {
        height: 9631,
        ease: Power3.easeIn,
      });
      line5_1.delay(3.3);

      var allcontent = TweenMax.to($(".history_wrap"), 1, {
        onComplete: function () {
          var controller_bg = $.superscrollorama({
            triggerAtCenter: false,
            playoutAnimations: true,
            reverse: true,
          });

          if (ua.isiOS || ua.isAndroid || ua.isTablet) {
          } else {
            controller_bg.addTween(
              "#ContentsWrapHistoryKick",
              TweenMax.to($(".wide_img_box"), 0.001, {
                delay: 0.0,
                opacity: 1.0,
                top: 0,
                ease: Power2.easeIn,
              })
            );
            controller_bg.addTween(
              "#ContentsWrapHistoryKick",
              TweenMax.to($(".wide_img_bg"), 0.001, {
                delay: 0.0,
                opacity: 0.0,
                ease: Power2.easeIn,
              })
            );
          }
          controller_bg.addTween(
            ".year_1925",
            TweenMax.to($(".wide_img_box"), 0.001, {
              delay: 0.0,
              opacity: 0.0,
              top: -600,
              ease: Power2.easeIn,
            })
          );

          if (ua.isiOS) {
            $(window).off(".noScroll");
          } else if (ua.isAndroid || ua.isTablet) {
            $(window).off(".noScroll");
            ctrl_body_scrl(true);
          } else {
            ctrl_body_scrl(true);
          }
        },
        opacity: 1,
      });
      allcontent.delay(3.8);
      return;
    }
  });

  $(function () {
    $(".wrap_circle_md")
      .on("mouseenter", function () {
        var Animations = new TimelineLite();
        Animations.append(
          TweenMax.from($(this).find(".circle"), 0.35, { rotation: 0 }),
          TweenMax.to($(this).find(".circle"), 0.65, {
            width: 240,
            height: 240,
            ease: Power4.easeInOut,
          }),
          TweenMax.to($(this).find(".circle"), 0.65, {
            left: -20,
            top: -20,
            ease: Power4.easeInOut,
          })
        );
      })
      .on("mouseleave", function () {
        var Animations = new TimelineLite();
        Animations.append(
          TweenMax.from($(this).find(".circle"), 0.3, { rotation: 0 }),
          TweenMax.to($(this).find(".circle"), 0.3, {
            width: 180,
            height: 180,
          }),
          TweenMax.to($(this).find(".circle"), 0.3, { left: 10, top: 10 })
        );
      });
    $(".wrap_ellipse_md")
      .on("mouseenter", function () {
        var Animations = new TimelineLite();
        Animations.append(
          TweenMax.from($(this).find(".ellipse"), 0.35, { rotation: 0 }),
          TweenMax.to($(this).find(".ellipse"), 0.65, {
            width: 854,
            height: 173,
            ease: Power4.easeInOut,
          }),
          TweenMax.to($(this).find(".ellipse"), 0.65, {
            left: -61,
            top: -4.5,
            ease: Power4.easeInOut,
          })
        );
      })
      .on("mouseleave", function () {
        var Animations = new TimelineLite();
        Animations.append(
          TweenMax.from($(this).find(".ellipse"), 0.3, { rotation: 0 }),
          TweenMax.to($(this).find(".ellipse"), 0.3, {
            width: 712,
            height: 144,
          }),
          TweenMax.to($(this).find(".ellipse"), 0.3, { left: 10, top: 10 })
        );
      });

  });
  /*
  $(function(){
  	$('.wrap_circle_md').on('mouseleave',function() {
  		var Animations = new TimelineLite();
  		Animations.append(
  			TweenMax.from($(this).find('.circle'), .3, { rotation: 0}),
  			TweenMax.to($(this).find('.circle'), .3, { rotation: 180}),
  			TweenMax.to($(this).find('.circle'), .3, {width: 180,height: 180}),
  			TweenMax.to($(this).find('.circle'), .3, {left: 10,top: 10})
  			)
  	});
  });
  */

  $(function () {
    if (ua.isiOS || ua.isAndroid || ua.isTablet) {
      $(".showcase_img1").css("opacity", 1);
      $(".showcase_img2").css("opacity", 1);
      $(".showcase_img3").css("opacity", 1);
      $(".showcase_img4").css("opacity", 1);
      $(".showcase_img5").css("opacity", 1);
      $(".showcase_img6").css("opacity", 1);
      $(".showcase_img7").css("opacity", 1);
      $(".showcase_img8").css("opacity", 1);
      $(".showcase_img9").css("opacity", 1);
      $(".showcase_img10").css("opacity", 1);
      $(".showcase_img11").css("opacity", 1);
      $(".showcase_img12").css("opacity", 1);
      $(".showcase_img13").css("opacity", 1);
      $(".showcase_img14").css("opacity", 1);
      $(".showcase_img15").css("opacity", 1);
      $(".showcase_img16").css("opacity", 1);
      $(".showcase_img17").css("opacity", 1);
      $(".showcase_img18").css("opacity", 1);
      $(".showcase_img19").css("opacity", 1);
      $(".showcase_img20").css("opacity", 1);
      $(".showcase_img21").css("opacity", 1);
      $(".showcase_img22").css("opacity", 1);
      $(".showcase_img23").css("opacity", 1);
      $(".showcase_img24").css("opacity", 1);
      $(".showcase_img25").css("opacity", 1);
      $(".showcase_img26").css("opacity", 1);
      $(".showcase_img27").css("opacity", 1);
      $(".showcase_img28").css("opacity", 1);
      $(".showcase_img29").css("opacity", 1);
      $(".showcase_img30").css("opacity", 1);
      $(".showcase_img31").css("opacity", 1);
      $(".digest-Outro").css("opacity", 1);
    } else {
      var controller = $.superscrollorama({
        triggerAtCenter: true,
        playoutAnimations: true,
        reverse: true,
      });

      controller.addTween(
        "#showcase1_start",
        TweenMax.to($(".showcase_img1"), 0.5, {
          delay: 0.0,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase1_start",
        TweenMax.to($(".showcase_img2"), 0.5, {
          delay: 0.1,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase1_start",
        TweenMax.to($(".showcase_img3"), 0.5, {
          delay: 0.2,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase1_start",
        TweenMax.to($(".showcase_img4"), 0.5, {
          delay: 0.3,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );

      controller.addTween(
        "#showcase2_start",
        TweenMax.to($(".showcase_img5"), 0.5, {
          delay: 0.0,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase2_start",
        TweenMax.to($(".showcase_img6"), 0.5, {
          delay: 0.1,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase2_start",
        TweenMax.to($(".showcase_img7"), 0.5, {
          delay: 0.2,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase2_start",
        TweenMax.to($(".showcase_img8"), 0.5, {
          delay: 0.3,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );

      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img9"), 0.5, {
          delay: 0.0,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img10"), 0.5, {
          delay: 0.1,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );

      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img11"), 0.5, {
          delay: 0.2,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );

      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img12"), 0.5, {
          delay: 0.3,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img13"), 0.5, {
          delay: 0.4,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img14"), 0.5, {
          delay: 0.5,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );

      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img15"), 0.5, {
          delay: 0.2,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img16"), 0.5, {
          delay: 0.3,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );

      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img17"), 0.5, {
          delay: 0.4,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img18"), 0.5, {
          delay: 0.5,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase3_start",
        TweenMax.to($(".showcase_img19"), 0.5, {
          delay: 0.6,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );

      controller.addTween(
        "#showcase4_start",
        TweenMax.to($(".showcase_img20"), 0.5, {
          delay: 0.0,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase4_start",
        TweenMax.to($(".showcase_img21"), 0.5, {
          delay: 0.1,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase4_start",
        TweenMax.to($(".showcase_img22"), 0.5, {
          delay: 0.2,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase4_start",
        TweenMax.to($(".showcase_img23"), 0.5, {
          delay: 0.3,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase4_start",
        TweenMax.to($(".showcase_img24"), 0.5, {
          delay: 0.4,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
      controller.addTween(
        "#showcase4_start",
        TweenMax.to($(".showcase_img25"), 0.5, {
          delay: 0.5,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );

      controller.addTween(
        ".digest-Outro",
        TweenMax.to($(".digest-Outro"), 0.5, {
          delay: 0.5,
          opacity: 1,
          ease: Power2.easeIn,
        })
      );
    }
  });

  var scrTop_now = 0;
  var setMarginTop_now = 0;
  var setMarginTop_max = 30;
  var scrTID;
  function init_Scrl() {
    if (ua.isiOS || ua.isAndroid || ua.isTablet) {
      return;
    }
    scrTop_now = 0;
    $(window).scroll(function () {
      var scrTop = $(window).scrollTop();
      var scrLeft = $(window).scrollLeft();
      var setMarginTop = 0;
      var bt = $(".wrap_circle_md, .wrap_circle_md_noanime");
      var act = true;

      setMarginTop = (scrTop_now - scrTop) * 0.15;
      setMarginTop = Math.floor(setMarginTop);

      if (setMarginTop > 0 && setMarginTop < setMarginTop_now) {
        act = false;
      }
      if (setMarginTop < 0 && setMarginTop > setMarginTop_now) {
        act = false;
      }
      if (setMarginTop > setMarginTop_max) {
        setMarginTop = setMarginTop_max;
      }
      if (setMarginTop < setMarginTop_max * -1) {
        setMarginTop = setMarginTop_max * -1;
      }
      if (act) {
        //console.log("scrTop:"+scrTop+", scrTop_now:"+scrTop_now+", setMarginTop:"+setMarginTop);
        set_bt_css(bt, setMarginTop);
      }
      clearTimeout(scrTID);
      scrTID = setTimeout("init_Scrl_back();", 60);
      scrTop_now = scrTop;
      setMarginTop_now = setMarginTop;
    });
  }
  function init_Scrl_back() {
    var bt = $(".wrap_circle_md, .wrap_circle_md_noanime");
    set_bt_css(bt, 0);
  }
  function set_bt_css(bt, val) {
    bt.css("transform", "translate(0px, " + val + "px)");
  }

  function ctrl_body_scrl(cond) {
    var target = $("body");
    var ctrl_e = true;

    if (ctrl_e) {
      if (cond) {
        target.addClass("content_show");
      } else {
        target.removeClass("content_show");
      }
    } else {
      target.addClass("content_show");
      if (cond) {
        $("html,body").animate({ scrollTop: 0 }, 1050, "easeInOutExpo");
        $(".wide_img_box").animate({ opacity: 1, top: 95 }, 0);
      } else {
        $("html,body").delay(25).animate({ scrollTop: 0 }, 1, "easeInOutExpo");
      }
    }
  }

  outroIntersectionObserver()
  function outroIntersectionObserver(){
    var $outro = $(".digest-Outro");
    if($(window).height() * 0.5  < $outro.outerHeight()) return;
    var outroObserver = new IntersectionObserver(doWhenOutroIntersected,{
      rootMargin: "0px",
      threshold: 0
    });
    outroObserver.observe($outro.get(0));

    function doWhenOutroIntersected(entries) {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          $(entry.target).animate({"opacity": 1}, 400, "swing");
        }
      });
    }

  }
})($brand);
